import { PreferredAvailability, SeriesPlanningMode } from '@/models/appointment/Appointment.ts';

// Default series config applied when AUTO planning mode is first seeded: flexible availability, no fixed time.
// The user can change the time-of-day preference afterwards; these are defaults, not a forced override.
export const SERIES_AUTO_SUGGESTION_DEFAULTS = {
    planning_mode: SeriesPlanningMode.AUTO,
    preferred_availability: PreferredAvailability.FLEXIBLE,
    preferred_time: undefined,
};
